module.exports = __webpack_public_path__ + "img/img_34.f9bad34b.png";